
    import React from 'react';
    import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../../../tools/webpack/svgSpriteLoader/icon.tsx";

    const symbol = new SpriteSymbol({
  "id": "dots_y1Z/w",
  "use": "dots_y1Z/w-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dots_y1Z/w\">\n  <circle cx=\"50%\" cy=\"50%\" r=\"23px\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" fill=\"none\" stroke-dasharray=\"0, 12\" stroke-dashoffset=\"1\" />\n</symbol>"
});
    sprite.add(symbol);

    const DotsY1ZWSpriteSymbolComponent = props => {
      return React.createElement(SpriteSymbolComponent, {glyph: "dots_y1Z/w", width: 48, height: 48, ...props })
    }

    export { DotsY1ZWSpriteSymbolComponent as ReactComponent };
  